<template>
	<div>
		<model :dialogVisible='dialogVisible' @opened='opened' width='12.86rem'>
			<div class="model-warp">
				<div class="label-list">
					<div class="label-item" >
						<div class="label-line bgred">
						</div>
						<div class="label-content">
							<div class="label-name">
								库存数量
							</div>
							<div class="label-value">
								401.5
								<span class="unit">吨</span>
							</div>
						</div>

					</div>
					<div class="label-item" >
						<div class="label-line bggreen">
						</div>
						<div class="label-content">
							<div class="label-name">
								采购数量
							</div>
							<div class="label-value">
								2630.5
								<span class="unit">吨</span>
							</div>
						</div>
					
					</div>
					<div class="label-item" >
						<div class="label-line bgpurple">
						</div>
						<div class="label-content">
							<div class="label-name">
								消耗数量
							</div>
							<div class="label-value">
								2229
								<span class="unit">吨</span>
							</div>
						</div>
					
					</div>
					<div class="label-item" >
						<div class="label-line bgyellow">
						</div>
						<div class="label-content">
							<div class="label-name">
								配方数量
							</div>
							<div class="label-value">
								45
								<span class="unit">个</span>
							</div>
						</div>
					
					</div>
					<div class="label-item" >
						<div class="label-line bgblue">
						</div>
						<div class="label-content">
							<div class="label-name">
								可饲喂天数
							</div>
							<div class="label-value">
								90
								<span class="unit">天</span>
							</div>
						</div>
					
					</div>
				</div>
				<div class="model-chart">
					<div class="chart-left">
						
						<span class="chart-title">采购与消耗趋势</span>
						<el-dropdown style='align-self: flex-end;' trigger="click">
							<span class="el-dropdown-link">
								近一年<i class="el-icon-caret-bottom el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item>近一年</el-dropdown-item>
								<el-dropdown-item>近半个月</el-dropdown-item>
								<el-dropdown-item>近一个月</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<div class="lineChart" id="modelChart1"></div>
					</div>
					<div class="chart-right">
						<span class="chart-title">养殖成本分析</span>
						<el-dropdown style='align-self: flex-end;' trigger="click">
							<span class="el-dropdown-link">
								近一年<i class="el-icon-caret-bottom el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item>近一年</el-dropdown-item>
								<el-dropdown-item>近半个月</el-dropdown-item>
								<el-dropdown-item>近一个月</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<div class="lineChart" id="modelChart11"></div>
					</div>
				</div>
				<div class="model-chart" style="margin-top: 0.45rem;">
					<div class="chart-left">
						
						<span class="chart-title">库存种类占比分析</span>
						
						<div class="lineChart" id="modelChart2" style="margin: 0;"></div>
						<div class="legend">
							<div class="legend-item" v-for='(item ,index) in pieData' :key='index'>
								<i class="circle" :style="{'background':item.color}"></i>
								<div class="legend-name">
									<span>{{item.name}}</span>
									<span>{{item.value}}%</span>
								</div>
										
							</div>
						</div>
					</div>
					<div class="chart-right">
						<span class="chart-title">农资消耗占比</span>
						
						<div class="lineChart" id="modelChart22" style="margin: 0;"></div>
						<div class="legend">
							<div class="legend-item" v-for='(item ,index) in pieData' :key='index'>
								<i class="circle" :style="{'background':item.color}"></i>
								<div class="legend-name">
									<span>{{item.name}}</span>
									<span>{{item.value}}%</span>
								</div>
				
							</div>
						</div>
					</div>
				</div>
			</div>
		</model>
	</div>


</template>

<script>
	import model from './model.vue'
	export default {
		components: {
			model
		},
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			},

		},
		data() {
			return {
				day1: [{
						title: '采购数量',
						month: ['22-05','22-06','22-07','22-08','22-09','22-10', '22-11', '22-12', '23-01', '23-02', '23-03', '23-04'],
						value: [280, 138, 194, 218, 135, 347, 79,133,210,186,255,129]
					},
					{
						title: '消耗数量',
						month: ['22-05','22-06','22-07','22-08','22-09','22-10', '22-11', '22-12', '23-01', '23-02', '23-03', '23-04'],
						value: [354, 245, 156, 97,274 ,217, 119,196,106,216,255,183]
					},
				],
				costData:[
					{
						title: '养殖成本',
						month: ['05','06','07','08','09','10', '11', '12', '01', '02', '03', '04'],
						value: [3.1, 3.5, 4.0, 3.6, 3.9, 4.3, 4.5,4.9,4.1,3.4,3.8,4.5]
					}
				],
				pieData: [
					{
						value: 60,
						name: '饲草',
						color:'#3AFFFB'
					},
					{
						value: 10,
						name: '秸秆',
						color:'#FFC700'
					},
					
					{
						value: 20,
						name: '复合饲料',
						color:'#7239EA'
					},{
						value: 10,
						name: ' 豆粕 ',
						color:'#165DFF'
					},
					
				],


			};
		},
		watch: {
			dialogVisible(val) {
				console.log(val)
			}
		},
		mounted() {
			console.log(1111)

		},

		methods: {
			opened() {
				this.setLineData(this.day1, 'modelChart1',true)
				this.setLineData(this.costData, 'modelChart11',false)
				console.log(222)

				this.pieChart(this.pieData, 'modelChart2',['30%', '50%'])
				this.pieChart(this.pieData, 'modelChart22','50%')
			},
			pieChart(data, dom,radius) {
				// var sum = 0
				// Object.values(data).forEach((item) => {
				//     return sum = sum + item
				// }, 0)
				var myChart = this.$echarts.init(document.getElementById(dom));
				var option = {
					// color: ['#0EDAE2', '#5D2CFE', '#E7C660', '#2C76FE'],
					color: ['#3AFFFB','#FFC700', '#7239EA',  '#165DFF'],
					title: {
						show: true,
						left: '45%',
						top: '0%',
						// text: `共计(家)\n\n ${sum}`,

					},
					top:'0%',
					grid: {
						top: '1px',
						          left: '1px',
						          right: '1px',
						          bottom: '1px',
						          containLabel: true,
					},
					tooltip: {
						trigger: 'item',
						axisPointer: {
							type: 'shadow',
						},
						backgroundColor: 'rgba(255,255,255,0.8)',
						borderColor: '#292929',
						borderWidth: 1,
						textStyle: {
							color: '#050F37',
						},
						formatter: '{b} {d}%\n\n'
					},

					series: [{
						type: 'pie',
						radius: radius,
						// avoidLabelOverlap: false,
						label: {
							show: true,
							position: 'outside',
							color: '#FFFFFF',
							formatter: ' {b} {d}% \n\n',
							padding: [0, -70],
							alignTo: 'labelLine'
						},
						center: ['50%', '60%'],
						labelLine: {
							show: true,
							length: 20,
							length2: 80,
							lineStyle: {
								color: '#73c0de',
							}
						},
						data: data
					}]
				};
				myChart.clear();
				myChart.setOption(option)
				window.addEventListener('resize', () => {
					myChart.resize()
				})
			},

			setLineData(data, dom,smooth) {
				const colors = ['#00FEFF', '#1B7EF2', '#40FF00'];
				const legend = [];
				const series = [];
				let xAxis = [];
				let seriesColors = [{
						color0: 'rgba(0,246,236,0.48)',
						color1: 'rgba(91,233,255,0)'
					},
					{
						color0: 'rgba(27,126,242,0.52)',
						color1: 'rgba(27,126,242,0)'
					}
				];
				data.forEach((item, index) => {
					legend.push({
						name: item.title,
						textStyle: {
							color: '#FFFFFF',
							fontSize: '0.13rem'
						},
						
						// icon: 'roundRect',
						// itemWidth: 4,
						// itemhight: 4,
					})
					xAxis = item.month
					series.push({
						smooth: smooth,
						name: item.title,
						type: "line",
						showSymbol: false,
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
									offset: 0,
									color: seriesColors[index].color0 // 0% 处的颜色
								}, {
									offset: 1,
									color: seriesColors[index].color1 // 100% 处的颜色
								}],
								global: false // 缺省为 false
							}
						},
						lineStyle: {
							width: 2,
						},
						color: colors[index],
						data: item.value,
					})
				})
				const line = {
					dom,
					xAxis,
					legend: {
						icon: 'rectangle',
						itemWidth: 15,
						itemHeight: 2,
						data: legend,
						// align:'center',
						// x: 'right',
						// y: 'top',
						x: 'center',
						y: 'top',
						show:smooth,
						padding: [0, 0, 0, 0],
						top: "0%",
						// right: "3%",
						// itemWidth: 8,
						// itemHeight: 8,
						// padding: [10, 0, 0, 0],
					},
					series: series
				}
				this.lineChart(line)
			},
			lineChart(data) {
				this.chart = this.$echarts.init(document.getElementById(data.dom))
				// 隐藏动画加载效果。
				var option = {
					color: ['#FFF200', '#00FEFF', '#FFF200'],
					tooltip: {
						trigger: 'axis',
						padding: [5, 20],
						backgroundColor: 'rgba(255,255,255,0.8)',
						// borderColor: 'rgba(18, 36, 132, 1)',
						borderColor: '#292929',
						borderWidth: 1,
						textStyle: {
							color: '#050F37',
						},
					},
					legend: data.legend,
					grid: {
						top: '15%',
						left: '0%',
						right: '5%',
						bottom: '0%',
						containLabel: true,
					},
					xAxis: {
						type: 'category',
						boundaryGap: true,

						axisLabel: {
							color: '#00FEFF',
							fontSize: '0.15rem',
							rotate: 40
						},
						axisLine: {
							symbol: ['none', 'arrow'],
							show: true, // X轴 网格线 颜色类型的修改
							// symbolSize: [10, 15],
							symbolOffset: [0, 6],
							symbolSize: [6, 6],
							lineStyle: {
								color: 'rgba(0,254,255,0.2)',
								type: 'solid',
							},
						},
						axisTick: {
							// X轴线 刻度线
							show: false,
							// inside: false,
							// alignWithLabel: true
						},
						data: data.xAxis,
					},
					yAxis: {
						name:data.dom=='modelChart11'?'元/只':'单位：吨',
						nameTextStyle: {
							color: '#00FEFF',
							padding: [3, 10, 0, 0],
							fontSize: '0.15rem',
						},
						// max: 320,
						scale: true,
						type: 'value',
						splitNumber: 6,

						axisLine: {
							symbol: ['none', 'arrow'],
							show: true, // X轴 网格线 颜色类型的修改
							// symbolSize: [10, 15],
							symbolOffset: [0, 6],
							symbolSize: [6, 6],
							lineStyle: {
								color: 'rgba(0,254,255,0.2)',
								type: 'solid',
							},
						},
						splitLine: {
							lineStyle: {
								type: 'soild',
								color: 'rgba(0,254,255,0.02)'
							}
						},
						axisLabel: {

							color: '#00FEFF',
							fontSize: '0.15rem',
						},
					},
					series: data.series,
				}
				this.chart.clear();
				this.chart.setOption(option)
				window.addEventListener('resize', () => {
					this.chart.resize()
				})
			},

		},
	};
</script>
<style lang="scss" scoped>
	.model-warp {
		padding-top: 0.68rem;
		padding-left: 0.25rem;
		padding-right: 0.25rem;
		.label-list {
			display: flex;

			.label-item {
				display: flex;
				width: 2.13rem;
				height: 0.49rem;
				align-items: center;

				.label-line {
					width: 0.08rem;
					height: 0.38rem;
					// background: #FE2C7D;
					border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
					margin-right: 0.11rem;
				}

				.label-content {
					justify-content: space-between;
					display: flex;
					flex-direction: column;
					height: 0.49rem;

					.label-name {
						font-size: 0.15rem;
						font-family: Source Han Sans CN-Regular, Source Han Sans CN;
						font-weight: 400;
						color: #FFFFFF;
					}

					.label-value {
						font-size: 0.2rem;
						font-family: Source Han Sans CN-Medium, Source Han Sans CN;
						font-weight: 500;
						color: #00FEFF;

						.unit {
							font-size: 0.15rem;
							color: #FAFAFA;
						}
					}
				}
			}
		}

		.model-chart {
			display: flex;
			width: 100%;
			margin-top: 0.74rem;
			justify-content: space-between;
			// height: 4.38rem;
			.legend {
				height: 0.67rem;
				width: 100%;
				display: flex;
				flex-wrap: wrap;
			
				.legend-item {
					width: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
			
					.circle {
						width: 0.08rem;
						height: 0.08rem;
						background: #3AFFFB;
						border-radius: 1.25rem 1.25rem 1.25rem 1.25rem;
						margin-right: 0.1rem;
					}
			
					.legend-name {
						width: 1.49rem;
						display: flex;
						justify-content: space-between;
						font-size: 0.13rem;
						font-family: Source Han Sans CN-Normal, Source Han Sans CN;
						font-weight: 350;
						color: #00FEFF;
					}
				}
			}
			.el-dropdown-link{
				color:#00FEFF;padding:0.06rem;font-size: 0.15rem;
			}
			.lineChart {
				margin-top: .35rem;
				width: 100%;
				height: 2.8rem;
			}
			.chart-left {
				display: flex;
				flex-direction: column;
				width: 50%;
				padding-left: 0.3rem;
				
				

			}

			.chart-title {
				font-size: 0.23rem;
				font-family: Source Han Sans CN-Medium, Source Han Sans CN;
				font-weight: 500;
				color: #00FEFF;
				
			}

			.chart-right {
				// padding-bottom: 0.25rem;
				width: 50%;
				height: 100%;
				display: flex;
				flex-direction: column;
				padding-left: 0.3rem;

				// .lineChart {
				// 	// margin-top: .36rem;
				// 	width: 100%;
				// 	flex: 1;
				// }

				
			}
		}

	}
</style>